import * as React from 'react';

import { LoginMessagePanel } from '../../../templates/login-message-panel/login-message-panel';

export interface RecoverSuccessProps {
  backAction: () => void;
  actionLink: () => void;
  type: 'password' | 'username';
}
const SUCCESS_MESSAGE_PASSWORD =
  'Almost ready! Please, check your email inbox and follow the instructions.';
const SUCCESS_MESSAGE_USERNAME =
  'Good news! We sent your username to your email. Want to try login again?';

export const RecoverSuccess = ({
  actionLink,
  backAction,
  type,
}: RecoverSuccessProps) => {
  return (
    <LoginMessagePanel
      textLink="Go to Login"
      actionLink={actionLink}
      title={`Recover your ${type}`}
      type="success"
      message={
        type === 'password'
          ? SUCCESS_MESSAGE_PASSWORD
          : SUCCESS_MESSAGE_USERNAME
      }
      backAction={backAction}
    />
  );
};
